import React from 'react';
import PropTypes from 'prop-types';
import config from 'cfg';
import auth from 'dash-front/auth';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import CopyToClipboard from 'react-copy-to-clipboard';
import InterestedList from './InterestsList';
import { SMLinkTable, SMLinkAddButtons } from 'dash-front/campaign/containers/SMLink/SMLinkManager';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Snackbar from 'material-ui/Snackbar';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import Dialog from 'material-ui/Dialog';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import SocialIcon from 'material-ui/svg-icons/social/share';
import LockIcon from 'material-ui/svg-icons/action/lock';

import IconCalendar from 'material-ui/svg-icons/action/today';
import IconTemplate from 'material-ui/svg-icons/image/style';

import AddIcon from 'material-ui/svg-icons/content/add-circle-outline';

import InterestedIcon from 'material-ui/svg-icons/toggle/star';
import CampaignsList from './CampaignsList';
import TemplatesList from './TemplatesList';

const Section = ({ icon, title, subTitle, children }) => (
    <section style={{ display: 'flex', margin: '10px 0', padding: '10px 0', borderBottom: '1px solid #ccc' }}>
        {icon}
        <div style={{ width: 200, padding: 10 }}>
            <div>{title}</div>
            {subTitle && <div>{subTitle}</div>}
        </div>
        <div style={{ flexGrow: 1 }}>{children}</div>
    </section>
);

class Account extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            // isLoading: true,
            saveSuccess: false,
            saveError: false,
            copyToastOpen: false,
            showSMDialog: false,
        };

        this.loadData();
    }

    loadData = () => {
        return fetch(`/api/users/${auth.getUser()._id}?access_token=${auth.getAccessToken()}`)
            .then(response => response.json())
            .then(user => {
                this.setState({ user });
            });
    };

    saveDomains = e => {
        const newDomainsStr = e.target.value;

        const newDomains = Array.isArray(newDomainsStr) ? _.uniq(newDomainsStr) : _.uniq(newDomainsStr.split('\n'));
        const body = {
            allowedDomains: newDomains,
        };

        this.setState({ saveSuccess: false });

        return fetch(`/api/users/${auth.getUser()._id}?access_token=${auth.getAccessToken()}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
            .then(response => {
                if (response.ok) {
                    return response.json().then(user => {
                        this.setState({
                            saveSuccess: true,
                            user,
                        });
                        auth.saveUser(user);
                    });
                } else {
                    this.setState({ saveError: true });
                }
            })
            .catch(err => {
                this.setState({ saveError: true, isSaving: false });
                console.error(err);
            });
    };

    getScriptSingle = () => {
        return `<script type="text/javascript" src="${config.WDPLinkr.injector()}" crossorigin></script>`;
    };
    getScriptAdv = () => {
        const { user } = this.state;
        if (!user) return;

        return `<script type="text/javascript" src="${config.WDPLinkr.injector()}" crossorigin></script>
<script type="text/javascript">
    WDPDefaults.set("client", "${user.client}");
    WDPDefaults.set("user", "${user.username}");
    WDPDefaults.set("theme", "${user.defaultTheme}");
    WDPDefaults.set("token", "${user.accessToken}");
    WDPDefaults.set("ga",    "${user.defaultProps.GA || ''}");
    WDPDefaults.set("load",  "js");
    WDPDefaults.set("lang",  "${user.defaultProps.lang || 'en'}");
</script>`;
    };

    handleSMDialogOpen = () => {
        this.setState({ showSMDialog: true });
    };

    handleSMDialogClose = () => {
        this.setState({ showSMDialog: false });
    };

    renderIndications() {
        return [
            // this.state.isSaving ? (
            //     <CircularProgress key="saving" size={0.4} style={{ position: 'absolute', right: 0, top: 0 }} />
            // ) : "",
            // this.state.saveSuccess ? (
            //     <DoneIcon key="save-success" style={{ position: 'absolute', right: 5, bottom: 15 }} />
            // ) : "",
            <Snackbar
                open={this.state.saveSuccess}
                key="save-success-snack"
                message="Domains have been successfully saved"
                autoHideDuration={4000}
            />,
            <Snackbar
                open={this.state.saveError}
                key="save-error-snack"
                className="snackbar-error"
                message="Server error. Records are not saved "
                action="close"
                onActionTouchTap={() => this.setState({ saveError: false })}
            />,
            <Snackbar
                open={this.state.copyToastOpen}
                key="snck-copied-msg"
                message="Copied!"
                autoHideDuration={4000}
                onActionTouchTap={() => this.setState({ copyToastOpen: false })}
            />,
        ];
    }

    render() {
        var iconStyle = {
            width: 36,
            height: 36,
        };
        const user = this.state.user;
        const userDomains =
            user && (Array.isArray(user.allowedDomains) ? user.allowedDomains.join('\n') : user.allowedDomains);

        var domainsString = this.state.allowedDomains || userDomains;

        // if (!user) return <div />;
        return (
            <div className="row">
                <Section icon={<LockIcon color="gray" style={iconStyle} />} title="Access token">
                    <div className="content">
                        <div className="value">
                            <TextField
                                onBlur={this.saveDomains}
                                onChange={e => {
                                    this.setState({ allowedDomains: e.target.value });
                                }}
                                value={domainsString}
                                style={{ marginTop: -12 }}
                                errorText={this.state.error}
                                multiLine
                                rows={1}
                                floatingLabelText="Allowed domains"
                                hintText="Enter allowed domains (top level)"
                            />
                        </div>
                    </div>

                    <TextField
                        style={{ width: 300 }}
                        value={user && user.accessToken}
                        floatingLabelText="Access token"
                        floatingLabelFixed
                    />
                </Section>
                <Section icon={<SettingsIcon color="gray" style={iconStyle} />} title="Default settings">
                    <RaisedButton href="account/defaults" label="Edit defaults" />
                </Section>
                <Section icon={<IconCalendar color="gray" style={iconStyle} />} title="Default calendar">
                    <CampaignsList />
                </Section>
                <Section icon={<IconTemplate color="gray" style={iconStyle} />} title="Default template">
                    <TemplatesList />
                </Section>

                <Section icon={<InterestedIcon color="gray" style={iconStyle} />} title="Interests">
                    <InterestedList />
                    <FlatButton
                        icon={<AddIcon />}
                        label="Manage interests"
                        onTouchTap={() => {
                            browserHistory.push({
                                pathname: `/interests`,
                            });
                        }}
                    />
                </Section>

                <Section icon={<SocialIcon color="gray" style={iconStyle} />} title="Social links">
                    <SMLinkTable />
                    <FlatButton
                        icon={<AddIcon />}
                        label="Connect social network"
                        onTouchTap={this.handleSMDialogOpen}
                    />
                </Section>

                {/* <div className="row settings">
                    <div className="col-xs-12">
                        <SocialIcon color="gray" style={iconStyle} />
                        <div className="info-block">
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                Social media links{' '}
                                <IconButton onTouchTap={this.handleSMDialogOpen}>
                                    <AddIcon />
                                </IconButton>
                            </div>
                        </div>
                        <div className="content">
                            <SMLinkTable />
                        </div>
                    </div>
                </div> */}

                {/* <div className="row settings">
                    <div className="col-xs-12">
                        <CodeIcon color="gray" style={iconStyle} />
                        <div className="info-block">
                            <div>Injector code</div>
                            <div className="secondary">Basic</div>
                        </div>
                        <div className="content clearfix">
                            <textarea
                                className="with-code"
                                readOnly
                                style={{ width: '100%' }}
                                value={this.getScriptSingle()}
                            />
                            <CopyToClipboard
                                text={this.getScriptSingle()}
                                onCopy={() =>
                                    this.setState({
                                        copyToastOpen: true,
                                    })
                                }
                            >
                                <FlatButton
                                    style={{ margin: '5px 0', float: 'right' }}
                                    label="Copy to clipboard"
                                    icon={<CopyIcon />}
                                />
                            </CopyToClipboard>
                        </div>

                        <div className="info-block no-image">
                            <div className="secondary">Advanced</div>
                        </div>
                        <div className="content">
                            <textarea
                                className="with-code"
                                readOnly
                                rows={12}
                                style={{ width: '100%' }}
                                value={this.getScriptAdv()}
                            />
                            <CopyToClipboard
                                text={this.getScriptAdv() || ''}
                                onCopy={() =>
                                    this.setState({
                                        copyToastOpen: true,
                                    })
                                }
                            >
                                <FlatButton
                                    style={{ margin: '5px 0', float: 'right' }}
                                    label="Copy to clipboard"
                                    icon={<CopyIcon />}
                                />
                            </CopyToClipboard>
                        </div>
                    </div>
                </div> */}

                {this.renderIndications()}
                <Dialog open={this.state.showSMDialog} onRequestClose={this.handleSMDialogClose}>
                    <h4>Link your social account</h4>
                    <SMLinkAddButtons onAdd={this.handleSMDialogClose} />
                </Dialog>
            </div>
        );
    }
}
export default Account;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/account/Account.js
 **/